var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4L11.3819 5.26152V11.6539L20 11.5854V4ZM4.00476 12.3475L4.00515 17.7871L10.5383 18.6829L10.5331 12.3898L4.00476 12.3475ZM11.3134 12.4347L11.3255 18.7802L19.9919 20L19.994 12.449L11.3134 12.4347ZM4 6.26545L4.00605 11.7024L10.5392 11.6653L10.5362 5.37748L4 6.26545Z",
    fill: "#455079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.e02d7e00fceaba04e18b4aa0df4e6c5c.svg";
export { ForwardRef as ReactComponent };